<template>
  <div class="gVoice-Inner">
    <article
      flat
      :to="{
        name: 'gallery-detail',
        params: { itemId: item.shouhinId },
      }"
      class="gVoice-Card fc-gray-8"
      :class="`gVoice-Card-screen${screenType}`"
      v-for="(item, index) in voiceList"
      :key="`voice-${item.shouhinId}-${index}`"
    >
      <div class="gVoice-CardInner">
        <SoundPlay2
          @click.stop
          :key="`sound-${item.shouhinId}-${index}`"
          :soundData="item"
          class="mx-auto"
        />
        <router-link
          :to="{
            name: 'gallery-detail',
            params: { itemId: item.shouhinId },
          }"
          class="pt-2 fc-gray-6 d-block"
        >
          <div class="gVoice-Card_Item lh-s fs-xs fc-gray-6 mb-1">
            {{ item.shouhinTitle }}
          </div>
          <div class="gVoice-Card_Name text-right">
            <v-icon v-if="item.creatorName" small class="mr-1 mb-1">mic</v-icon>
            <router-link
              v-if="screenType == 1"
              :to="{
                name: 'creator-detail',
                params: { creatorKbn: 2, creatorId: item.creatorId },
              }"
              class="font-weight-bold sw-Link-primary sw-Ellipsis"
            >
              {{ item.creatorName }}
            </router-link>
            <span v-else>{{ item.creatorName }}</span>
          </div>
          <div class="sw-Link-primary sw-Ellipsis fs-xs lh-s text-right">
            <router-link
              v-if="screenType == 1"
              :to="{
                name: 'portalSearchResult-noWord',
                params: { type: 'voice' },
                query: { shouhinKbn: item.shouhinKbn },
              }"
              class="font-weight-bold sw-Link-primary sw-Ellipsis sw-Pointer"
            >
              {{ item.shouhinmei }}
            </router-link>
            <span v-else>{{ item.shouhinmei }}</span>
          </div>
        </router-link>
      </div>
    </article>

    <div
      class="gVoice-Card gVoice-Card-spacer"
      v-for="(item, index) in 11"
      :key="`spacer${index}`"
    ></div>
  </div>
</template>

<script>
import NameOrder from "@/components/NameOrder";
import SoundPlay2 from "@/components/SoundPlay2";

export default {
  name: "GalleryVoiceList",
  components: {
    NameOrder,
    SoundPlay2,
  },
  props: {
    voiceList: {
      type: Array,
      required: true,
    },
    screenType: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      durationList: [],
    };
  },
  watch: {
    voiceList: {
      handler(newVoiceList) {
        this.resetAudioStates();
      },
      deep: true
    }
  },
  methods: {
    resetAudioStates() {
      // SoundPlay2コンポーネントをリセットするために
      // keyを変更することで強制的に再マウントさせる
      this.$nextTick(() => {
        // 必要に応じてここで追加の初期化処理を行う
      });
    },
    toVoiceDetail(i) {
      const shouhinId = this.voiceList[i].shouhinId;
      this.$router.push({
        name: "gallery-detail",
        params: { itemId: shouhinId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/sass/import.scss";

.gVoice {
  &-Inner {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -16px;
  }

  &-CardInner {
    cursor: pointer;
    &:hover::before {
      position: absolute;
      top: -16px;
      right: 8px;
      bottom: -8px;
      left: 8px;
      z-index: -1;
      display: block;
      content: "";
      background-color: var(--gray-1);
      border-radius: 4px;
      @include media($sm) {
        right: 0;
        left: 0;
      }
    }
  }

  &-Card {
    position: relative;
    z-index: $z-content;
    flex-grow: 1;
    width: (100%/12);
    min-width: 160px;
    padding: 0 16px;
    margin: 24px 0 16px;

    @include media($sm) {
      margin-top: 16px;
      margin-bottom: 24px;
    }

    &_LinkBox {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: $z-content;
      display: block;
    }

    &_Icon {
      flex-shrink: 0;
      width: 100px;
      height: 100px;
      margin-right: 8px;
    }

    &_Name {
      @include ellipsis;

      font-size: $fs-xs;
      font-weight: bold;
      line-height: 1;
      color: var(--gray-6);
    }

    &_Item {
      @include clamp(2);
      min-height: 30px;
    }

    &_Footer {
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: $fs-xs;
      color: var(--gray-6);
    }

    &_Deadline {
      flex-grow: 2;
      text-align: right;
    }

    &_Bottom {
      position: absolute;
      right: 16px;
      left: 16px;
      bottom: -40px;
    }
  }

  &-Card-spacer {
    height: 0;
    margin: 0;

    &::after {
      content: none;
    }

    &:hover::before {
      content: none;
    }
  }
}
</style>
